import { ApplicantStage } from 'src/graphql/types/applicants'

/** Pastel palette — Tailwind 300-shade accents, soft on a gray-50 row. */
export const STAGE_PASTEL = {
  [ApplicantStage.PROSPECT]: '#93C5FD', // sky-300
  [ApplicantStage.HIRED]: '#86EFAC', // green-300
  [ApplicantStage.NOT_INTERESTED]: '#D1D5DB', // gray-300
  [ApplicantStage.DISQUALIFIED]: '#FCA5A5', // red-300
  [ApplicantStage.TERMINATED]: '#C4B5FD', // violet-300
} as const satisfies Record<ApplicantStage, string>

export interface StageDef {
  stage: ApplicantStage
  label: string
  color: string
}

/**
 * Visual order shared by Pipeline Summary rows and Pipeline Activity lines.
 * Both cards consume this list so the eye can trace a stage's color from a
 * row on the left card to a line on the right card without a legend lookup.
 */
export const STAGE_ORDER: ReadonlyArray<StageDef> = [
  {
    stage: ApplicantStage.PROSPECT,
    label: 'Prospects',
    color: STAGE_PASTEL[ApplicantStage.PROSPECT],
  },
  {
    stage: ApplicantStage.HIRED,
    label: 'Hired',
    color: STAGE_PASTEL[ApplicantStage.HIRED],
  },
  {
    stage: ApplicantStage.NOT_INTERESTED,
    label: 'Not Interested',
    color: STAGE_PASTEL[ApplicantStage.NOT_INTERESTED],
  },
  {
    stage: ApplicantStage.DISQUALIFIED,
    label: 'Disqualified',
    color: STAGE_PASTEL[ApplicantStage.DISQUALIFIED],
  },
  {
    stage: ApplicantStage.TERMINATED,
    label: 'Terminated',
    color: STAGE_PASTEL[ApplicantStage.TERMINATED],
  },
]
